export default "__VITE_ASSET__fsm$4lMS__"